import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Crown, Sparkles } from 'lucide-react';

const MembershipModal = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    onClose();
    navigate('/membership');
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md" data-testid="membership-modal">
        <DialogHeader>
          <div className="flex items-center justify-center mb-4">
            <div className="w-16 h-16 bg-accent rounded-full flex items-center justify-center">
              <Crown className="w-8 h-8 text-accent-foreground" />
            </div>
          </div>
          <DialogTitle className="text-2xl font-heading font-bold text-center">
            Membership Required
          </DialogTitle>
          <DialogDescription className="text-center text-muted-foreground">
            Unlock full access to XpatSphere with an annual membership for just $15/year
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 my-6">
          <div className="flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-primary" />
            <span>Create unlimited events</span>
          </div>
          <div className="flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-primary" />
            <span>RSVP to any event</span>
          </div>
          <div className="flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-primary" />
            <span>Join discussions & connect with expats</span>
          </div>
        </div>

        <div className="flex gap-3">
          <Button
            onClick={handleUpgrade}
            className="flex-1 bg-primary text-primary-foreground hover:bg-primary/90 h-12 rounded-full font-bold brutal-shadow"
            data-testid="upgrade-button"
          >
            Become a Member
          </Button>
          <Button
            variant="outline"
            onClick={onClose}
            className="px-6 h-12 rounded-full font-bold border-2"
            data-testid="modal-close-button"
          >
            Later
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MembershipModal;
